// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_oR_","buttons":"Footer_buttons__1DweD"};